import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext } from "@nuxtjs/composition-api";
import { GETTERS as TOAST_GETTERS, ACTIONS as TOAST_ACTIONS } from "~/store/affility/user/feedback/modals/toast-notification/names";
import { ToastNotificationEnum } from "~/store/affility/user/feedback/modals/toast-notification/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'ToastNotification',
  setup(__props) {

const context = useContext();

const toastType: ToastNotificationEnum = computed(() => {
    return context.store.getters[`affility/user/feedback/modals/toast-notification/${TOAST_GETTERS.TOAST_TYPE}`];
})

const isVisible: boolean = computed(() => {
    return context.store.getters[`affility/user/feedback/modals/toast-notification/${TOAST_GETTERS.IS_TOAST_OPEN}`];
})

const toastDescription: string = computed(() => {
    return context.store.getters[`affility/user/feedback/modals/toast-notification/${TOAST_GETTERS.TOAST_DESCRIPTION}`];
})

const toastIconColor = computed(() => {
    switch (toastType.value) {
        case ToastNotificationEnum.INFO:
            return 'primary-icons-primary'
        case ToastNotificationEnum.ERROR:
            return 'error-notifications-icons-error-notifications'
    }
})

const handleClear = () => {
    context.store.dispatch(`affility/user/feedback/modals/toast-notification/${TOAST_ACTIONS.CLOSE_TOAST}`);
}

return { __sfc: true,context, toastType, isVisible, toastDescription, toastIconColor, handleClear }
}

})